<template>
  <div class="public-page-content" v-html="$t('CookiePolicyContent')">
  </div>
</template>

<script>

export default {
  name: "CookiePolicy",
  methods: {
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem(
          "theme",
          this.$vuetify.theme.dark ? "dark" : "light"
      );
    },
  },
}
</script>

<style scoped>

</style>
